import React from 'react';
import _ from 'lodash';
import {Header, Segment, Form, Divider} from 'semantic-ui-react';
import {ContentDispatch} from 'framework';
import ValidateContinueButton from 'app-ui-componentlibrary/dist/go/components/common/ValidateContinueButton';
import ReactHtmlParser from 'react-html-parser';
import {evaluateOperator} from 'common/utils';

import {connectDynamic, DynamicComponent} from 'go/components/dynamic/dynamicComponent';

/* Deprecated, only functionality that should be in here is a <form> wrapper */
export class DynamicFormModule extends DynamicComponent {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.contents !== this.props.contents) {
      this.setState({
        fullValidationRun: false,
      });
    }
  }

  /*
    DEPRECATED:  use ShowHide component instead of 'isHidden' option in config
  */
  renderHiddenComponents(data, args) {
    let render = true;
    args &&
      args.forEach((arg) => {
        switch (arg.operator) {
          case 'equal':
            render &= _.isEqual(_.get(data, arg.dataPath), arg.value);
            break;
          case 'equalListAnd':
            render &= arg.value
              .map((v) => _.isEqual(_.get(data, arg.dataPath), v))
              .every((v) => v === true);
            break;
          case 'equalListOr':
            render &= arg.value
              .map((v) => _.isEqual(_.get(data, arg.dataPath), v))
              .some((v) => v === true);
            break;
          case 'notEqual':
            render &= !_.isEqual(_.get(data, arg.dataPath), arg.value);
            break;
          case 'notEqualListAnd':
            render &= arg.value
              .map((v) => !_.isEqual(_.get(data, arg.dataPath), v))
              .every((v) => v === true);
            break;
          case 'notEqualListOr':
            render &= arg.value
              .map((v) => !_.isEqual(_.get(data, arg.dataPath), v))
              .some((v) => v === true);
            break;
          default:
        }
      });
    return render;
  }

  renderMain(data, options, noStyling, bottomMargin) {
    //Evaluate whether or not the form should be disabled
    if (this.props.disableIf) {
      const {disableIf} = this.props;
      var disabled = true;
      _.forEach(disableIf, (rule) => {
        disabled &= evaluateOperator(
          rule.operator,
          _.get(this.props, rule.propsPath),
          rule.value
        );
      });

      //Component is dependent on disabled option being a boolean, can't use 0/1
      if (disabled) options.disabled = true;
    }
    return (
      <React.Fragment>
        {this.props.title && <Header as="h1">{this.props.title}</Header>}
        {this.props.guidance && <p className="leadParagraph">{this.props.guidance}</p>}
        <Form>
          {this.props.contents &&
            this.props.contents.map((content, index) => {
              let hideComponent =
                content.isHidden !== undefined &&
                this.renderHiddenComponents(data, content.isHidden.args);
              let toRender = (
                <div key={index}>
                  <ContentDispatch
                    config={content}
                    formOptions={options}
                    location={''}
                    extraProps={this.props.applicationId || null}
                    setCurrentFieldList={this.props.setCurrentFieldList}
                    isHidden={hideComponent}
                  />
                  {content.appendedMessage && (
                    <p>{ReactHtmlParser(content.appendedMessage)}</p>
                  )}
                  {(!noStyling || content.appendedMessage) && bottomMargin && <br />}
                </div>
              );
              return toRender;
            })}
        </Form>
        {!noStyling && !this.props.noButton && (
          <ValidateContinueButton
            fullValidationRun={this.state.fullValidationRun}
            validateContinueClick={this.validateContinueClick}
            message={this.props.validateContinueErrorMsg}
          />
        )}
      </React.Fragment>
    );
  }

  render() {
    const options = this.props.formOptions || {};
    const {noStyling} = options;
    const bottomMargin = options.bottomMargin === 'no' ? false : true; // set it to 'no' in the json to remove <br /> if not needed
    const data =
      _.get(this.props, 'data.payload') || _.get(this.props, 'allData.payload');

    if (noStyling) {
      return this.renderMain(data, options, noStyling, bottomMargin);
    } else {
      return (
        <Segment padded vertical={noStyling} className="narrow">
          {this.renderMain(data, options, noStyling, bottomMargin)}
        </Segment>
      );
    }
  }
}

export default connectDynamic(DynamicFormModule);
